import { Box, Divider } from '@mui/material';
import Subtitle from 'src/components/Subtitle';

import { ProfitabilityTable } from '../../components/ProfitabilityTable';
import { ProfitabilityCharts } from '../ProfitabilityCharts';

type ProfitabilityTableAndChartsProps = {
  hashId: string;
  hasPermission: boolean;
};

export function ProfitabilityTableAndCharts({
  hashId,
  hasPermission,
}: ProfitabilityTableAndChartsProps) {
  return (
    <Box sx={{ '.apexcharts-menu-item.exportCSV': { display: 'none' } }}>
      <Subtitle title="Rentabilidade diária" />
      <Box display="flex" gap={2} width="100%" flexDirection="column">
        <ProfitabilityTable hashId={hashId} hasPermission={hasPermission} />
        <Divider />
        <ProfitabilityCharts hashId={hashId} hasPermission={hasPermission} />
      </Box>
    </Box>
  );
}
